var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminLaunchpad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_101_1106)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.8438,
    r: 20,
    fill: "url(#paint0_linear_101_1106)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.8438,
    r: 20,
    fill: "url(#paint1_linear_101_1106)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.8438,
    r: 17.5,
    stroke: "url(#paint2_linear_101_1106)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.8438,
    r: 17.5,
    stroke: "url(#paint3_linear_101_1106)",
    strokeWidth: 5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3427 12.5394C31.304 12.4515 31.2337 12.3812 31.1493 12.346C31.1036 12.3249 26.6026 10.4331 22.8998 14.1323C22.193 14.8391 21.5108 15.6725 20.8849 16.5516L20.0304 16.3547C18.7399 16.0558 17.4107 16.4356 16.4718 17.3709L14.1404 19.7058C13.5216 20.3247 13.9189 21.3761 14.7804 21.4429L18.0647 21.7067C17.9206 22.0899 17.7975 22.4662 17.7272 22.7159C17.6639 22.9374 17.6744 23.166 17.7412 23.3769C17.147 23.5387 16.6054 23.8341 16.2995 24.14C15.6244 24.8116 15.0231 27.7549 14.9105 28.3386C14.8613 28.6199 15.111 28.8344 15.3501 28.7781C15.9338 28.6621 18.877 28.0608 19.5487 27.3892C19.8687 27.0692 20.157 26.5206 20.3152 25.9474C20.5403 26.0178 20.7689 26.0178 20.9763 25.958H20.9798C21.2295 25.8877 21.5952 25.7716 21.9855 25.6204L22.2493 28.9047C22.3161 29.7663 23.371 30.1601 23.9864 29.5447L26.3213 27.2098C27.2566 26.2745 27.6399 24.9417 27.3375 23.6512L27.1406 22.7967C28.0197 22.1708 28.8531 21.4886 29.5599 20.7818C33.2591 17.0861 31.3638 12.5851 31.3427 12.5394ZM14.6749 20.2368L17.0063 17.9019C17.7623 17.1459 18.8313 16.8435 19.8616 17.0861L20.4278 17.2162C19.5873 18.4786 18.877 19.8008 18.3636 20.9752L14.8402 20.6939C14.6116 20.6728 14.5132 20.395 14.6749 20.2368ZM19.0177 26.8617C18.6907 27.1887 17.0696 27.6423 15.7615 27.9307C16.0463 26.6191 16.4999 25.0015 16.8305 24.6745C17.1153 24.3862 17.6709 24.1365 18.2124 24.038L19.6542 25.4798C19.6506 25.4938 19.6506 25.5079 19.6471 25.5255C19.5416 26.0424 19.2849 26.5945 19.0177 26.8617ZM20.368 25.1281L18.5606 23.3207C18.4551 23.2152 18.4129 23.057 18.4515 22.9163C18.4832 22.8073 18.543 22.6033 18.6203 22.3748L21.3139 25.0683C21.1521 25.1246 20.9376 25.1914 20.7724 25.2371C20.6317 25.2793 20.477 25.2371 20.368 25.1281ZM26.6026 23.827C26.8417 24.8644 26.5393 25.9299 25.7868 26.6824L23.4519 29.0173C23.2901 29.179 23.0158 29.077 22.9947 28.852L22.7134 25.3286C23.8879 24.8187 25.2101 24.1048 26.4725 23.2644L26.6026 23.827ZM22.084 24.7765L18.9087 21.6012C19.8054 19.4104 21.5179 16.5727 23.4273 14.6633C25.6074 12.4831 28.4733 12.1561 30.7062 12.9789C30.9699 13.7174 32.0178 17.2654 29.0219 20.2614C27.1124 22.1708 24.2747 23.8833 22.084 24.7765Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8341 15.1978C23.8248 16.207 23.8248 17.8422 24.8341 18.8549C25.8433 19.8641 27.4784 19.8641 28.4911 18.8549C29.5003 17.8457 29.5003 16.207 28.4911 15.1978C27.4784 14.1886 25.8433 14.1886 24.8341 15.1978ZM27.9601 18.3239C27.2428 19.0413 26.0824 19.0413 25.365 18.3239C24.6477 17.6066 24.6477 16.4461 25.365 15.7288C26.0824 15.0115 27.2428 15.0115 27.9601 15.7288C28.674 16.4461 28.674 17.6101 27.9601 18.3239Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_101_1106",
    x: 0.847312,
    y: 0.84375,
    width: 43.9929,
    height: 43.9929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.99644
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.998219
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_1106"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_1106",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_101_1106"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_1106",
    x1: 38.7548,
    y1: 35.0635,
    x2: 26.6622,
    y2: 0.171924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#011789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.590159,
    stopColor: "#1A23FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2FFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_1106",
    x1: 5.10198,
    y1: 38.5855,
    x2: 40.5855,
    y2: 3.10198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_1106",
    x1: 24.4598,
    y1: 40.8437,
    x2: 42.8267,
    y2: 21.5508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C95FF",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C8FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_101_1106",
    x1: 0.84375,
    y1: 3.70089,
    x2: 29.7595,
    y2: 47.8632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminLaunchpad);
export default __webpack_public_path__ + "static/media/admin_launchpad.73ea5b670775dd66b42179a4890e2dc6.svg";
export { ForwardRef as ReactComponent };